var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EC6500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning_svg__clip0_852_7672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.082 30.349C26.973 23.449 28.92 20 32 20c3.08 0 5.026 3.45 8.917 10.349l.485.86c3.234 5.732 4.85 8.599 3.39 10.695C43.33 44 39.715 44 32.484 44h-.97c-7.23 0-10.846 0-12.307-2.096-1.461-2.096.156-4.963 3.39-10.696l.484-.86zM32 25.667a1 1 0 011 1v6.666a1 1 0 11-2 0v-6.666a1 1 0 011-1zm0 13A1.333 1.333 0 1032 36a1.333 1.333 0 000 2.667z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__clip0_852_7672"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16 16)",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgWarning;